"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hooks_1 = require("@nef/hooks");
var FormField_1 = __importDefault(require("../FormField"));
var FormTextArea = react_1.default.forwardRef(function (_a, ref) {
    var autoResize = _a.autoResize, maxRows = _a.maxRows, rows = _a.rows, onInput = _a.onInput, props = __rest(_a, ["autoResize", "maxRows", "rows", "onInput"]);
    var textAreaRef = react_1.default.useRef();
    var handleAreaResize = function () {
        var padding = 14;
        var textareaLineHeight = 21;
        if (!maxRows ||
            Math.ceil((textAreaRef.current.scrollHeight - padding) / textareaLineHeight) <= maxRows) {
            textAreaRef.current.style.height = "auto";
            textAreaRef.current.style.height = textAreaRef.current.scrollHeight + "px";
        }
    };
    return (react_1.default.createElement(FormField_1.default, __assign({}, props, { type: "textarea", rows: maxRows && rows > maxRows ? maxRows : rows, onInput: autoResize ? handleAreaResize : onInput, ref: hooks_1.useCombinedRefs(textAreaRef, ref) })));
});
FormTextArea.displayName = "FormTextArea";
FormTextArea.defaultProps = {
    rows: 1,
    autoResize: true
};
exports.default = FormTextArea;
//# sourceMappingURL=index.js.map